// Module
var code = "<div class=\"h-100 home-mobile\" id=\"page-content\"> <div class=\"title\"> <div class=\"app-name\"> Apps <span id=\"version\"></span> </div> <div class=\"login\"> <i class=\"icon icon-user-circle\"></i> <span id=\"login\"></span> </div> </div> <div class=\"buttons\"> </div> </div>";
// Exports
export default code;